(() => {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.saveStyles(
        '.sc-center .img-box, .sc-center .flex__item--01, .sc-center .flex__item--02, .sc-gongjin__content--01'
    );

    ScrollTrigger.matchMedia({
        '(max-width: 750px)': () => {
            // center02 : 이미지 확대 및 텍스트
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-center',
                    pin: true,
                    scrub: 2,
                    end: '+=1500',
                    ease: 'none',
                    invalidateOnRefresh: true,
                },
            })
                .to('.sc-center .img-box', { paddingBottom: '100%' }, 'a')
                .to('.sc-center .wrap .only-mo', { paddingLeft: '0', paddingRight: 0 }, 'a')
                .to('.sc-center .flex__item--01', { opacity: 0 }, 'a')
                .to('.sc-center .flex__item--02', { opacity: 1 });

            // gongjin02 : parallax
            new setParallax('.sc-gongjin__content--02 .img-wrap', '.sc-gongjin__content--02 .img-box', '-4%', '4%');

            // footer : parallax
            new setParallax('.sc-outro .img-wrap', '.sc-outro .img-box', '-10%', '10%');
        },
        '(min-width: 751px)': () => {
            // center02 : 이미지 우측 이동, 텍스트 opaicty
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-center',
                    ease: 'none',
                    pin: true,
                    scrub: 2,
                    end: '+=2000',
                    invalidateOnRefresh: true,
                },
            })
                .to('.sc-center .img-box', { width: '50%', paddingBottom: '50%', right: '50%' }, 'a')
                .to('.sc-center .flex__item--01', { opacity: 0 }, 'a')
                .to('.sc-center .img-box', { right: 0 })
                .to('.sc-center .flex__item--02', { opacity: 1 });

            // gongjin01 : 가로 스크롤
            gsap.to('.sc-gongjin__list', {
                xPercent: -60,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.sc-gongjin__content--01',
                    pin: true,
                    scrub: 1,
                    end: '+=2500',
                    invalidateOnRefresh: true,
                },
            });

            // gongjin02 : parallax
            new setParallax('.sc-gongjin__content--02 .img-wrap', '.sc-gongjin__content--02 .img-box', '-5%', '5%');

            // footer : parallax
            new setParallax('.sc-outro .img-wrap', '.sc-outro .img-box', '-18%', '18%');
        },
        all: () => {
            //center01 : 이미지 scale, 텍스트 opacity
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-center',
                    start: '0% 50%',
                    end: '70% 100%',
                    scrub: 2,
                    ease: 'none',
                },
            })
                .from('.sc-center img', { scale: 1.2 }, 'a')
                .from('.sc-center .flex__item--01', { yPercent: -25 }, 'a')
                .from('.sc-center .flex__item--01 *', { opacity: 0.3 }, 'a');
        },
    });
})();
